(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroMobileCarousel {
    constructor(el) {
      this.grid = el.querySelector('.hero__media-grid');
      this.dots = el.querySelectorAll('.hero__carousel-dot');
      if (!this.grid || !this.dots.length) return;
      this.count = this.dots.length;
      this.current = 0;
      this._onScroll = this._onScroll.bind(this);
      this.grid.addEventListener('scroll', this._onScroll, { passive: true });
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          this.grid.scrollTo({ left: i * this.grid.offsetWidth, behavior: 'smooth' });
        });
      });
    }
    _onScroll() {
      const idx = Math.round(this.grid.scrollLeft / this.grid.offsetWidth);
      if (idx !== this.current && idx >= 0 && idx < this.count) {
        this.dots[this.current].classList.remove('active');
        this.dots[idx].classList.add('active');
        this.current = idx;
      }
    }
  }
  document.querySelectorAll('.hero--carousel-mobile').forEach(el => {
    new HeroMobileCarousel(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
